import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { GroupService } from '../services/group.service';
import { isStateModeGroup } from '../../shared/util/state-mode.util';

/**
 * Keeps a state unit (tasks/state-mode.md) out of pages it has no use for: MedicAI Connect, lab orders, invoicing,
 * procedure coding.
 * Waits for the selected practice, then sends a unit to the schedule.
 */
export const stateModeGuard: CanActivateFn = () => {
  const router = inject(Router);
  return inject(GroupService).selectedGroup$.pipe(
    filter((group) => !!group),
    take(1),
    map((group) => (isStateModeGroup(group) ? router.parseUrl('/patients/schedule') : true)),
  );
};
